/**
 * Universal search endpoints.
 *
 * Backed by GET /api/search-cache (routes/search.routes.ts), which returns
 * the three DB-backed caches that already exist — user search index, group
 * cache, shared-mailbox cache — plus placeholder buckets for sources not
 * yet ported (drives/printers/fileServers/shares). Shape:
 *
 *   { success, cache: { users: {data,count,lastUpdated}, groups: {...},
 *     sharedMailboxes: {...}, drives, printers, ... } }
 */

import { apiGet } from '../client.js';

/** @returns {Promise<{ success: boolean, cache: Record<string, any> }>} */
export const fetchSearchCache = () => apiGet('/api/search-cache');
